{
    "positioning": {
        "offset": {
            "default": 11,
            "viewport": 8
        },
        "divider": {
            "half": 2
        }
    },
    "alignment": {
        "mapping": {
            "first": "left",
            "last": "right",
            "center": "center"
        }
    },
    "padding": {
        "classes": {
            "compact": "hmf-p-xxs",
            "none": "hmf-p-0",
            "default": "hmf-p-s"
        }
    },
    "background": {
        "classes": {
            "dark": "popover-dark",
            "light": "popover-light"
        }
    },
    "comments": {
        "offset": "Default offset distance between popover and anchor element (10px), and minimum distance from viewport edges (8px)",
        "divider": "Mathematical constants used for centering calculations",
        "alignment": "Maps interface alignment values to corresponding CSS class names",
        "padding": "CSS class mappings for different padding variants",
        "background": "CSS class mappings for different background color themes"
    }
}
